import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "./Styles.css";
import useCreateData from "../../API/useCreateData.js";
import ConfirmMessage from "../../Components/ConfirmInside/ConfirmMessage.jsx";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Download,
  Thumbnails,
  Counter,
} from "yet-another-react-lightbox/plugins";

import { useNavigate } from "react-router-dom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";
import PaletteIcon from "@mui/icons-material/Palette";
import useFetchData from "../../API/useFetchData.js";
import useFetchMedia from "../../API/useGetMedia.js";
import useDeleteImages from "../../API/useDeleteImages.js";
import { usePhotos } from "../../Redux/PhotosContext.js";
import SubmenuLogoComponent from "./LogoSubmenu.jsx";
import SubmenuFrames from "./FramesSubmenu.jsx";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import ReplayIcon from "@mui/icons-material/Replay";

import SuccessCard from "../../Components/MessageAfterAction/Card.jsx";
import FalseCard from "../../Components/MessageAfterAction/FalseCard.jsx";
const ImageView = () => {
  const {
    photos,
    setPhotos,
    Entered,
    setIsEntered,
    originalImages,
    setOriginalImages,
    originalImagesLogo,
    setOriginalImagesLogo,
    toApprovePhotos,
    setToApprovePhotos,
  } = usePhotos();
  const [index, setindexState] = useState(
    parseInt(localStorage.getItem("index")) || 0
  );
  const setindex = (index) => {
    setindexState(index);
    localStorage.setItem("index", index);
  };
  const [open, setOpen] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [isSubmenuVisible, setSubmenuVisible] = useState(false);
  const [isMmsMenuVisible, setMmsMenuVisible] = useState(false);

  const [currentPhoto, setCurrentPhoto] = useState(null);

  const { fetchData: fetcthPhotos } = useFetchData("/manager/photos");
  const { fetchMedia } = useFetchMedia();
  const { createData } = useCreateData(
    "/manager/photos/approve",
    "photos accepeted successfully",
    "Error accepting photos"
  );
  const { deleteItem } = useDeleteImages();
  const [showSuccessCard, setShowSuccessCard] = useState(false);
  const [showFalseCard, setShowFalseCard] = useState(false);
  const [status, setStatus] = useState("Accepted");
  const navigate = useNavigate();
  useEffect(() => {
    if (photos.length > index) {
      setCurrentPhoto(photos[index].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photos]);
  useEffect(() => {
    if (!Entered) {
      const loadPhotos = async () => {
        try {
          const response = await fetcthPhotos({ approved: "false" });

          // Set initial photo data (without URLs)
          const initialPhotos = response.map((photo) => ({
            id: photo.id,
            url: null, // Placeholder for the actual media URL
            uploadedBy: photo.uploadedBy,
            approved: photo.approved,
            createdAt: photo.createdAt,
            updatedAt: photo.updatedAt,
            className: photo.className,
            yearName: photo.yearName,
          }));
          setPhotos(initialPhotos);

          const imageMap = {};

          const processImage = async (i) => {
            const photo = response[i];
            const media = await fetchMedia(photo.photoUrl);
            setPhotos((prevPhotos) =>
              prevPhotos.map((p) =>
                p.id === photo.id ? { ...p, url: media } : p
              )
            );
            imageMap[photo.id] = media.url;
          };

          // Fetch media URLs one by one and update the photos state
          let cont = false;
          if (index < response.length) {
            // start with the current index
            await processImage(index);
            cont = true;
          } else {
            setindex(0);
          }
          for (let i = 0; i < response.length; i++) {
            if (i === index && cont) continue;
            await processImage(i);
          }

          setOriginalImages(imageMap);
        } catch (error) {
          console.error("Error fetching photos:", error);
        }
        setIsEntered(true);
      };

      loadPhotos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOkClick = () => {
    setShowSuccessCard(false); // Close the success card
    setShowFalseCard(false);
  };
  const handleSlideChange = (index) => {
    setindex(index.index);
    if (photos.length > 0)
      setCurrentPhoto(photos[index.index % photos.length].id);
  };

  const toggleMmsMenu = () => {
    setSubmenuVisible(false);
    setMmsMenuVisible(!isMmsMenuVisible);
    // Close the other submenu
  };

  const toggleSubmenu = async () => {
    setMmsMenuVisible(false);
    setSubmenuVisible(!isSubmenuVisible);
  };

  const handleAccept = async () => {
    const idToAccept = currentPhoto;
    const approveImg = toApprovePhotos.find(
      (img) => img.photoId === idToAccept
    ) || { photoId: idToAccept };

    try {
      // Call the API with the list of IDs
      await createData([approveImg]).then(() => {
        if (index >= photos.length - 1) {
          setindex((prevIndex) => prevIndex % (photos.length - 1));
        }
        setPhotos((prevPhotos) =>
          prevPhotos.filter((photo) => idToAccept !== photo.id)
        );
        setToApprovePhotos((prevApprovedImages) =>
          prevApprovedImages.filter((img) => img.photoId !== idToAccept)
        );

        setShowSuccessCard(true);
        setStatus("Accepted");
      });
    } catch (error) {
      setShowFalseCard(true);
      setStatus("Accepted");
      console.error("Error accepting photos:", error);
    }
  };

  const handleDelete = async () => {
    const idToDelete = currentPhoto;
    try {
      // Call the API with the list of IDs
      const endpoint = "/manager/photos";
      await deleteItem(endpoint, [idToDelete]);
      if (index >= photos.length - 1) {
        setindex((prevIndex) => prevIndex % (photos.length - 1));
      }
      setPhotos((prevPhotos) =>
        prevPhotos.filter((photo) => idToDelete !== photo.id)
      );
      setToApprovePhotos((prevApprovedImages) =>
        prevApprovedImages.filter((img) => idToDelete !== img.photoId)
      );
      setShowSuccessCard(true);
      setStatus("Deleted");
    } catch (error) {
      setShowFalseCard(true);
      setStatus("Deleted");
      console.error("Error accepting photos:", error);
    }
  };
  const handleConfirmAction = async () => {
    try {
      if (actionType === "accept") {
        await handleAccept();
      } else if (actionType === "delete") {
        await handleDelete();
      } else if (actionType === "reset") {
        if (originalImages.length !== 0 || originalImagesLogo.length !== 0) {
          setPhotos((prevPhotos) =>
            prevPhotos.map((photo) => {
              if (photos[index].id === photo.id) {
                return {
                  ...photo,
                  url: {
                    ...photo.url, // Keep other properties of the 'url' object
                    url: originalImages[photo.id], // Update only the 'url' field
                  },
                  logoAdded: false, // Reset the logoAdded property
                };
              }
              return photo;
            })
          );
          setOriginalImagesLogo([]);
        }
      }
      setShowModal(false);
    } catch (err) {
      console.error("An error occurred. Please try again.", err);
    }
  };

  const handleActionClick = (type) => {
    setActionType(type);
    setShowModal(true);
  };

  const handleCancelAction = () => {
    setShowModal(false);
  };

  const galleryPhotos = photos.map((photo) => ({
    id: photo.id,
    src: photo.url ? photo.url.url : "",
  }));

  return (
    <>
      {open && (
        <Lightbox
          open={open}
          close={() => {
            setOpen(false);
            navigate("/");
          }}
          styles={{
            overlay: { pointerEvents: "auto" },
          }}
          slides={galleryPhotos}
          carousel={{ preload: 5 }}
          index={index}
          thumbnails={{
            imageFit: "cover",
          }}
          toolbar={{
            buttons: [
              <PaletteIcon
                key="palette-icon"
                style={{
                  fontSize: "1.5rem", // Increase the size of the icon
                  cursor: "pointer",
                  marginTop: "12px", // Move the icon down
                }}
                onClick={toggleSubmenu}
              />,
              <LocalPoliceIcon
                key="Mms-icon"
                style={{
                  fontSize: "1.5rem", // Increase the size of the icon
                  cursor: "pointer",
                  marginTop: "12px", // Move the icon down
                  marginLeft: "20px",
                }}
                onClick={toggleMmsMenu}
              />,
              <ReplayIcon
                key="Reset-icon"
                style={{
                  fontSize: "1.5rem", // Increase the size of the icon
                  cursor: "pointer",
                  marginTop: "12px", // Move the icon down
                  marginLeft: "20px",
                }}
                onClick={() => handleActionClick("reset")}
              />,
              <ThumbUpIcon
                key="-icon"
                style={{
                  fontSize: "1.5rem", // Increase the size of the icon
                  cursor: "pointer",
                  marginTop: "12px", // Move the icon down
                  marginLeft: "20px",
                }}
                onClick={() => handleActionClick("accept")}
              />,
              <DeleteIcon
                key="Reset-icon"
                style={{
                  fontSize: "1.5rem", // Increase the size of the icon
                  cursor: "pointer",
                  marginTop: "12px", // Move the icon down
                  marginLeft: "20px",
                }}
                onClick={() => handleActionClick("delete")}
              />,
              "close",
            ],
          }}
          plugins={[Download, Thumbnails, Counter]}
          on={{
            view: handleSlideChange, // Use the view callback to update the current index
          }}
        />
      )}
      {isSubmenuVisible && (
        <SubmenuFrames
          photos={photos}
          setPhotos={setPhotos}
          highlightedImages={[currentPhoto]}
          originalImages={originalImages}
          setOriginalImages={setOriginalImages}
          originalImagesLogo={originalImagesLogo}
          setOriginalImagesLogo={setOriginalImagesLogo}
          setApprovedImages={setToApprovePhotos}
        />
      )}
      {isMmsMenuVisible && (
        <SubmenuLogoComponent
          highlightedImages={[currentPhoto]}
          photos={photos}
          originalImages={originalImages}
          setOriginalImages={setOriginalImages}
          originalImagesLogo={originalImagesLogo}
          setOriginalImagesLogo={setOriginalImagesLogo}
          setPhotos={setPhotos}
          setApprovedImages={setToApprovePhotos}
        />
      )}
      <ConfirmMessage
        showModal={showModal}
        actionType={actionType}
        handleConfirmAction={handleConfirmAction}
        handleCancelAction={handleCancelAction}
        selectedPhotos={[currentPhoto]}
        AllPhotos={photos}
      />

      {showSuccessCard && (
        <SuccessCard onClose={handleOkClick} status={status} />
      )}
      {showFalseCard && <FalseCard onClose={handleOkClick} status={status} />}
    </>
  );
};

export default ImageView;
